<style scoped>
  .fa-asterisk {
    font-size: 10px;
  }
</style>

<template>
  <VPopover
    offset="0"
    @mouseleave="tootlTipIsOpen = false"
    :open="filters && tootlTipIsOpen"
    :placement="'right'"
  >
    <div class="tooltip-target">
      <a
        :href="route"
        @mouseover="tootlTipIsOpen = true"
        @mouseleave="tootlTipIsOpen = false"
      >
        {{ segment.name }}
      </a>
    </div>

    <template slot="popover">
      <h5 class="border-bottom-1 p-b-10 m-b-10 f-w-600">
        <i class="fa fa-filter" /> {{ contextCount > 1 ? 'Critérios' : 'Critério' }}
      </h5>
      <div
        v-for="(filter, index) in context"
        class="p-b-3 p-t-3"
      >
        <span v-if="index == 'type' && contextCount > 1">
          <br> <i class="fa fa-asterisk" /> {{ getFilterString(filter) }}
        </span>
        <span v-else-if="index != 'type'">
          <i
            class="fa fa-caret-right"
            v-if="index != 'type'"
          /> {{ getFilterString(filter) }}
        </span>
      </div>
    </template>
  </VPopover>
</template>

<script>
export default {
  props: ['route', 'segment', 'filters'],

  data () {
    return {
      tootlTipIsOpen: false,
    };
  },

  computed: {
    context () {
      if (! this.filters || ! this.filters.filters) {
        return {};
      }

      _.forIn(this.segment.context, (context, key) => {
        if (key == 'type') {
          return;
        }

        const filter = _.find(this.filters.filters, { filter: context.filter });

        if (! filter || (Object.keys(filter.options).length > 0 && ! filter.options[context.query])) {
          delete this.segment.context[key];
          return;
        }

        context.description = filter.description;
        context.operator = filter.operators[context.operator];
        context.hide_operators = filter.hide_operators;
        context.query = filter.options[context.query] || context.query;
      });

      this.segment.context.type = this.filters.types[this.segment.context.type];

      return this.segment.context;
    },

    contextCount () {
      let count = 0;

      _.forIn(this.context, (context, key) => {
        if (key != 'type') {
          count++;
        }
      });

      return count;
    },
  },

  methods: {
    getFilterString (filter) {
      if (! filter.description) {
        return filter;
      }

      let str = `${filter.description}: `;

      if (! filter.hide_operators && filter.operator) {
        str += filter.operator.toLowerCase();
      }

      str += ` ${filter.query}`;

      return str;
    },
  },
};
</script>
